import React from 'react'
import { UserData } from '../../common/core/entitites'
import { useAuth } from '../../common/context/auth'
const emptyUser: UserData = {
    id: '',
    email: '',
    name: '',
    organization: {
        organizationId: 0,
        country: '',
        name: '',
        qrId: '',
        stripeAccountId: '',
        stripeProductId: '',
    },
    country: 'bg',
    currency: 'BGN',
    phone: '',
    onboarding: {
        completed: true,
    },
}

const UserContext = React.createContext<{ user: UserData }>({ user: emptyUser })

function UserProvider({ children }: { children: React.ReactNode }) {
    const { user } = useAuth()
    if (!user) {
        return null
    }
    return <UserContext.Provider children={children} value={{ user }} />
}

function useUser() {
    const context = React.useContext(UserContext)
    if (context === undefined) {
        throw new Error(`useUser must be used within a UserProvider`)
    }
    if (!context.user) {
        throw new Error(`useUser must not be used when unauthorized`)
    }
    return context
}

export { UserProvider, useUser }
